<auth-template>
  <go-stepper #goStepper [goStepperClass]="'go-stepper-class'">
    <go-step [hideIndicator]="true">
      <email-and-password-form
        [isDashboard]="isDashboard"
        [mode]="mode"
        [lockEmailWith]="this.courseInvite?.invite?.email || email"
        [courseInvite]="courseInvite"
        (onComplete)="emailAndPasswordFormComplete($event)"
        (onNavigate)="navigate($event)">
      </email-and-password-form>
    </go-step>
    <go-step [hideIndicator]="skipEmailVerification || mode === SIGNUPMODES.STANDARD">
      @if (currentStep === signupStepsState.EMAIL_VERIFICATION) {
        <email-verification
          (onBack)="goBack()"
          [email]="emailAndPasswordData?.email"
          (onComplete)="emailVerificationComplete($event)">
        </email-verification>
      }
    </go-step>
    <go-step [hideIndicator]="true">
      <lti-confirmation (onBack)="goBack()" (onProceed)="onLTIVerficationProceed()" ></lti-confirmation>
    </go-step>
    <go-step [hideIndicator]="currentStep === signupStepsState.ORG_SEARCH || mode === SIGNUPMODES.STANDARD || !requiresAccountInfo ">
      <org-search
        [emailVerificationData]="emailVerificationData"
        [allOrgs]="allOrgs"
        [allowedOrgs]="allowedOrgs"
        (onCreateOrg)="createOrg($event)"
        (onSelectOrg)="orgSelectionComplete($event)"
        (onBack)="goBack()"
        (navigateToStudentStep)="navigateToStudentStep()"
        (reloadOrgs)="loadOrgs()">
      </org-search>
    </go-step>
    <go-step [hideIndicator]="currentStep === signupStepsState.EMAIL_VERIFICATION || currentStep === signupStepsState.ORG_SEARCH || mode === SIGNUPMODES.STANDARD || !requiresAccountInfo || isExistingOrg">
      <org-create
        [orgs]="allOrgs"
        [defaultName]="searchTerm"
        (onBack)="goBack()"
        (onComplete)="orgCreateComplete($event)"
        [email]="emailAndPasswordData?.email || ssoData?.sso_email"
        [unallowedDomain]="emailVerificationData?.unallowed_domains || ssoData?.unallowed_domains">
      </org-create>
    </go-step>
    <go-step [hideIndicator]="mode === SIGNUPMODES.STANDARD || !requiresAccountInfo">
      @if (loadAccountCreate()) {
        <account-create
          [emailVerificationData]="emailVerificationData"
          [emailAndPasswordData]="emailAndPasswordData"
          [courseInvite]="courseInvite"
          [ssoData]="ssoData"
          [infoKey]="infoKey"
          [org]="org"
          [mode]="mode"
          (onBack$)="goBack()"
          (onNavigate$)="navigate($event)"
          (reloadOrgs$)="loadOrgs()">
        </account-create>
      }
    </go-step>
    <go-step [hideIndicator]="true">
      <student-signup-message (onBack)="navigateToEmailAndPasswordStep()"></student-signup-message>
    </go-step>
  </go-stepper>
</auth-template>
